import { Button } from "@design-system/Button/Button";
import { useSideNavMode } from "@design-system/SideNav/SideNavProvider";
import { AddMemberIcon } from "@icons";
import { useInviteFirmMember } from "./useInviteFirmMember";
import styles from "./InviteMembersButton.module.scss";

/**
 * The org footer's invite-to-firm button, filling the row beside `?` at any
 * nav width. Hidden for users who can't invite and in a mini nav, where `?`
 * carries it instead.
 */
export const InviteMembersButton = () => {
    const inviteFirmMember = useInviteFirmMember();
    const isMini = useSideNavMode() === "mini";

    if (!inviteFirmMember || isMini) {
        return null;
    }

    return (
        <Button
            variant="primary"
            size="md"
            rightIcon={<AddMemberIcon />}
            className={styles.inviteMembersButton}
            onClick={inviteFirmMember}
        >
            <span className={styles.label}>Invite members</span>
        </Button>
    );
};
